import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { continueApplicationProcessing } from './application';
import { CreditTerms, Offer, QualificationStepResponse } from '../../../domain/qualification';
import { RootState } from '../../../store';

type CreditTermsState = {
  creditTerms: CreditTerms | null;
  conditionalApproval?: Required<QualificationStepResponse>['applicationMeta']['conditionalApproval'];
  offers: Offer[];
  selectedOfferId: string | null;
};

const initialState: CreditTermsState = {
  creditTerms: null,
  offers: [],
  selectedOfferId: null,
};

const slice = createSlice({
  name: 'credit-terms',
  initialState,
  reducers: {
    selectOffer: (state, action: PayloadAction<string>) => {
      state.selectedOfferId = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(
      continueApplicationProcessing,
      (
        state,
        {
          payload: {
            response: { creditTerms, applicationMeta, offers },
          },
        },
      ) => {
        const conditionalApproval =
          applicationMeta?.conditionalApproval === undefined
            ? state.conditionalApproval
            : applicationMeta.conditionalApproval;

        const updated: typeof state = {
          ...state,
          creditTerms: creditTerms ? creditTerms : state.creditTerms,
          conditionalApproval,
          offers: offers ?? state.offers,
        };
        return updated;
      },
    );
  },
});

export const { selectOffer } = slice.actions;
export const creditTermsReducer = slice.reducer;

export const selectCreditTerms = (state: RootState) => state.creditTerms;
